// رشته‌های مشترک پنل مدیریت (دکمه‌ها، وضعیت‌ها، پیام‌های عمومی).
// هر کامپوننت مدیریتی باید ابتدا این کلیدها را با t('admin.common.xxx') استفاده کند
// و فقط برای متن‌های اختصاصی خودش فایل admin/<ComponentName>.js بسازد.
export default {
  fa: {
    save: 'ذخیره',
    saveSettings: 'ذخیره تنظیمات',
    cancel: 'انصراف',
    delete: 'حذف',
    edit: 'ویرایش',
    add: 'افزودن',
    addNew: 'افزودن جدید',
    create: 'ایجاد',
    update: 'به‌روزرسانی',
    submit: 'ثبت',
    close: 'بستن',
    back: 'بازگشت',
    next: 'بعدی',
    previous: 'قبلی',
    confirm: 'تأیید',
    yes: 'بله',
    no: 'خیر',
    search: 'جستجو',
    filter: 'فیلتر',
    refresh: 'بارگذاری مجدد',
    export: 'خروجی',
    import: 'ورودی',
    view: 'مشاهده',
    viewDetails: 'مشاهده جزئیات',
    actions: 'عملیات',
    status: 'وضعیت',
    enabled: 'فعال',
    disabled: 'غیرفعال',
    active: 'فعال',
    inactive: 'غیرفعال',
    loading: 'در حال بارگذاری...',
    noData: 'داده‌ای برای نمایش وجود ندارد',
    name: 'نام',
    title: 'عنوان',
    description: 'توضیحات',
    type: 'نوع',
    date: 'تاریخ',
    createdAt: 'تاریخ ایجاد',
    updatedAt: 'تاریخ به‌روزرسانی',
    total: 'مجموع',
    page: 'صفحه',
    email: 'ایمیل',
    phone: 'شماره تلفن',
    user: 'کاربر',
    users: 'کاربران',
    success: 'موفق',
    error: 'خطا',
    networkError: 'خطا در ارتباط با سرور',
    loadError: 'خطا در بارگذاری اطلاعات',
    saveSuccess: 'با موفقیت ذخیره شد',
    saveError: 'خطا در ذخیره‌سازی',
    deleteConfirmTitle: 'آیا از حذف مطمئن هستید؟',
    deleteConfirmContent: 'این عملیات غیرقابل بازگشت است.',
    deleteSuccess: 'با موفقیت حذف شد',
    deleteError: 'خطا در حذف',
    updateSuccess: 'با موفقیت به‌روزرسانی شد',
    updateError: 'خطا در به‌روزرسانی',
    copySuccess: 'کپی شد!',
    requiredField: 'این فیلد الزامی است',
    all: 'همه',
    none: 'هیچکدام',
    unknown: 'نامشخص',
  },
  en: {
    save: 'Save',
    saveSettings: 'Save Settings',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    addNew: 'Add New',
    create: 'Create',
    update: 'Update',
    submit: 'Submit',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    search: 'Search',
    filter: 'Filter',
    refresh: 'Refresh',
    export: 'Export',
    import: 'Import',
    view: 'View',
    viewDetails: 'View Details',
    actions: 'Actions',
    status: 'Status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    active: 'Active',
    inactive: 'Inactive',
    loading: 'Loading...',
    noData: 'No data to display',
    name: 'Name',
    title: 'Title',
    description: 'Description',
    type: 'Type',
    date: 'Date',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    total: 'Total',
    page: 'Page',
    email: 'Email',
    phone: 'Phone Number',
    user: 'User',
    users: 'Users',
    success: 'Success',
    error: 'Error',
    networkError: 'Failed to connect to the server',
    loadError: 'Failed to load data',
    saveSuccess: 'Saved successfully',
    saveError: 'Failed to save',
    deleteConfirmTitle: 'Are you sure you want to delete this?',
    deleteConfirmContent: 'This action cannot be undone.',
    deleteSuccess: 'Deleted successfully',
    deleteError: 'Failed to delete',
    updateSuccess: 'Updated successfully',
    updateError: 'Failed to update',
    copySuccess: 'Copied!',
    requiredField: 'This field is required',
    all: 'All',
    none: 'None',
    unknown: 'Unknown',
  },
  de: {
    save: 'Speichern',
    saveSettings: 'Einstellungen speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    add: 'Hinzufügen',
    addNew: 'Neu hinzufügen',
    create: 'Erstellen',
    update: 'Aktualisieren',
    submit: 'Absenden',
    close: 'Schließen',
    back: 'Zurück',
    next: 'Weiter',
    previous: 'Zurück',
    confirm: 'Bestätigen',
    yes: 'Ja',
    no: 'Nein',
    search: 'Suchen',
    filter: 'Filter',
    refresh: 'Aktualisieren',
    export: 'Exportieren',
    import: 'Importieren',
    view: 'Ansehen',
    viewDetails: 'Details ansehen',
    actions: 'Aktionen',
    status: 'Status',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    loading: 'Wird geladen...',
    noData: 'Keine Daten vorhanden',
    name: 'Name',
    title: 'Titel',
    description: 'Beschreibung',
    type: 'Typ',
    date: 'Datum',
    createdAt: 'Erstellt am',
    updatedAt: 'Aktualisiert am',
    total: 'Gesamt',
    page: 'Seite',
    email: 'E-Mail',
    phone: 'Telefonnummer',
    user: 'Benutzer',
    users: 'Benutzer',
    success: 'Erfolg',
    error: 'Fehler',
    networkError: 'Verbindung zum Server fehlgeschlagen',
    loadError: 'Fehler beim Laden der Daten',
    saveSuccess: 'Erfolgreich gespeichert',
    saveError: 'Speichern fehlgeschlagen',
    deleteConfirmTitle: 'Möchten Sie dies wirklich löschen?',
    deleteConfirmContent: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    deleteSuccess: 'Erfolgreich gelöscht',
    deleteError: 'Löschen fehlgeschlagen',
    updateSuccess: 'Erfolgreich aktualisiert',
    updateError: 'Aktualisierung fehlgeschlagen',
    copySuccess: 'Kopiert!',
    requiredField: 'Dieses Feld ist erforderlich',
    all: 'Alle',
    none: 'Keine',
    unknown: 'Unbekannt',
  },
  es: {
    save: 'Guardar',
    saveSettings: 'Guardar configuración',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    add: 'Añadir',
    addNew: 'Añadir nuevo',
    create: 'Crear',
    update: 'Actualizar',
    submit: 'Enviar',
    close: 'Cerrar',
    back: 'Volver',
    next: 'Siguiente',
    previous: 'Anterior',
    confirm: 'Confirmar',
    yes: 'Sí',
    no: 'No',
    search: 'Buscar',
    filter: 'Filtrar',
    refresh: 'Actualizar',
    export: 'Exportar',
    import: 'Importar',
    view: 'Ver',
    viewDetails: 'Ver detalles',
    actions: 'Acciones',
    status: 'Estado',
    enabled: 'Habilitado',
    disabled: 'Deshabilitado',
    active: 'Activo',
    inactive: 'Inactivo',
    loading: 'Cargando...',
    noData: 'No hay datos para mostrar',
    name: 'Nombre',
    title: 'Título',
    description: 'Descripción',
    type: 'Tipo',
    date: 'Fecha',
    createdAt: 'Fecha de creación',
    updatedAt: 'Fecha de actualización',
    total: 'Total',
    page: 'Página',
    email: 'Correo electrónico',
    phone: 'Número de teléfono',
    user: 'Usuario',
    users: 'Usuarios',
    success: 'Éxito',
    error: 'Error',
    networkError: 'Error al conectar con el servidor',
    loadError: 'Error al cargar los datos',
    saveSuccess: 'Guardado con éxito',
    saveError: 'Error al guardar',
    deleteConfirmTitle: '¿Está seguro de que desea eliminar esto?',
    deleteConfirmContent: 'Esta acción no se puede deshacer.',
    deleteSuccess: 'Eliminado con éxito',
    deleteError: 'Error al eliminar',
    updateSuccess: 'Actualizado con éxito',
    updateError: 'Error al actualizar',
    copySuccess: '¡Copiado!',
    requiredField: 'Este campo es obligatorio',
    all: 'Todos',
    none: 'Ninguno',
    unknown: 'Desconocido',
  },
  fr: {
    save: 'Enregistrer',
    saveSettings: 'Enregistrer les paramètres',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    add: 'Ajouter',
    addNew: 'Ajouter un nouveau',
    create: 'Créer',
    update: 'Mettre à jour',
    submit: 'Envoyer',
    close: 'Fermer',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    confirm: 'Confirmer',
    yes: 'Oui',
    no: 'Non',
    search: 'Rechercher',
    filter: 'Filtrer',
    refresh: 'Actualiser',
    export: 'Exporter',
    import: 'Importer',
    view: 'Voir',
    viewDetails: 'Voir les détails',
    actions: 'Actions',
    status: 'Statut',
    enabled: 'Activé',
    disabled: 'Désactivé',
    active: 'Actif',
    inactive: 'Inactif',
    loading: 'Chargement...',
    noData: 'Aucune donnée à afficher',
    name: 'Nom',
    title: 'Titre',
    description: 'Description',
    type: 'Type',
    date: 'Date',
    createdAt: 'Créé le',
    updatedAt: 'Mis à jour le',
    total: 'Total',
    page: 'Page',
    email: 'E-mail',
    phone: 'Numéro de téléphone',
    user: 'Utilisateur',
    users: 'Utilisateurs',
    success: 'Succès',
    error: 'Erreur',
    networkError: 'Échec de la connexion au serveur',
    loadError: 'Échec du chargement des données',
    saveSuccess: 'Enregistré avec succès',
    saveError: "Échec de l'enregistrement",
    deleteConfirmTitle: 'Êtes-vous sûr de vouloir supprimer ceci ?',
    deleteConfirmContent: 'Cette action est irréversible.',
    deleteSuccess: 'Supprimé avec succès',
    deleteError: 'Échec de la suppression',
    updateSuccess: 'Mis à jour avec succès',
    updateError: 'Échec de la mise à jour',
    copySuccess: 'Copié !',
    requiredField: 'Ce champ est obligatoire',
    all: 'Tous',
    none: 'Aucun',
    unknown: 'Inconnu',
  },
  it: {
    save: 'Salva',
    saveSettings: 'Salva impostazioni',
    cancel: 'Annulla',
    delete: 'Elimina',
    edit: 'Modifica',
    add: 'Aggiungi',
    addNew: 'Aggiungi nuovo',
    create: 'Crea',
    update: 'Aggiorna',
    submit: 'Invia',
    close: 'Chiudi',
    back: 'Indietro',
    next: 'Avanti',
    previous: 'Precedente',
    confirm: 'Conferma',
    yes: 'Sì',
    no: 'No',
    search: 'Cerca',
    filter: 'Filtro',
    refresh: 'Aggiorna',
    export: 'Esporta',
    import: 'Importa',
    view: 'Visualizza',
    viewDetails: 'Visualizza dettagli',
    actions: 'Azioni',
    status: 'Stato',
    enabled: 'Abilitato',
    disabled: 'Disabilitato',
    active: 'Attivo',
    inactive: 'Inattivo',
    loading: 'Caricamento...',
    noData: 'Nessun dato da visualizzare',
    name: 'Nome',
    title: 'Titolo',
    description: 'Descrizione',
    type: 'Tipo',
    date: 'Data',
    createdAt: 'Creato il',
    updatedAt: 'Aggiornato il',
    total: 'Totale',
    page: 'Pagina',
    email: 'E-mail',
    phone: 'Numero di telefono',
    user: 'Utente',
    users: 'Utenti',
    success: 'Successo',
    error: 'Errore',
    networkError: 'Connessione al server non riuscita',
    loadError: 'Caricamento dei dati non riuscito',
    saveSuccess: 'Salvato con successo',
    saveError: 'Salvataggio non riuscito',
    deleteConfirmTitle: 'Sei sicuro di voler eliminare questo elemento?',
    deleteConfirmContent: "Questa azione non può essere annullata.",
    deleteSuccess: 'Eliminato con successo',
    deleteError: 'Eliminazione non riuscita',
    updateSuccess: 'Aggiornato con successo',
    updateError: 'Aggiornamento non riuscito',
    copySuccess: 'Copiato!',
    requiredField: 'Questo campo è obbligatorio',
    all: 'Tutti',
    none: 'Nessuno',
    unknown: 'Sconosciuto',
  },
  ja: {
    save: '保存',
    saveSettings: '設定を保存',
    cancel: 'キャンセル',
    delete: '削除',
    edit: '編集',
    add: '追加',
    addNew: '新規追加',
    create: '作成',
    update: '更新',
    submit: '送信',
    close: '閉じる',
    back: '戻る',
    next: '次へ',
    previous: '前へ',
    confirm: '確認',
    yes: 'はい',
    no: 'いいえ',
    search: '検索',
    filter: 'フィルター',
    refresh: '更新',
    export: 'エクスポート',
    import: 'インポート',
    view: '表示',
    viewDetails: '詳細を見る',
    actions: '操作',
    status: 'ステータス',
    enabled: '有効',
    disabled: '無効',
    active: '有効',
    inactive: '無効',
    loading: '読み込み中...',
    noData: '表示するデータがありません',
    name: '名前',
    title: 'タイトル',
    description: '説明',
    type: 'タイプ',
    date: '日付',
    createdAt: '作成日',
    updatedAt: '更新日',
    total: '合計',
    page: 'ページ',
    email: 'メール',
    phone: '電話番号',
    user: 'ユーザー',
    users: 'ユーザー',
    success: '成功',
    error: 'エラー',
    networkError: 'サーバーへの接続に失敗しました',
    loadError: 'データの読み込みに失敗しました',
    saveSuccess: '保存に成功しました',
    saveError: '保存に失敗しました',
    deleteConfirmTitle: '本当に削除しますか?',
    deleteConfirmContent: 'この操作は元に戻せません。',
    deleteSuccess: '削除に成功しました',
    deleteError: '削除に失敗しました',
    updateSuccess: '更新に成功しました',
    updateError: '更新に失敗しました',
    copySuccess: 'コピーしました!',
    requiredField: 'この項目は必須です',
    all: 'すべて',
    none: 'なし',
    unknown: '不明',
  },
  ko: {
    save: '저장',
    saveSettings: '설정 저장',
    cancel: '취소',
    delete: '삭제',
    edit: '수정',
    add: '추가',
    addNew: '새로 추가',
    create: '생성',
    update: '업데이트',
    submit: '제출',
    close: '닫기',
    back: '뒤로',
    next: '다음',
    previous: '이전',
    confirm: '확인',
    yes: '예',
    no: '아니요',
    search: '검색',
    filter: '필터',
    refresh: '새로고침',
    export: '내보내기',
    import: '가져오기',
    view: '보기',
    viewDetails: '자세히 보기',
    actions: '작업',
    status: '상태',
    enabled: '활성화',
    disabled: '비활성화',
    active: '활성',
    inactive: '비활성',
    loading: '불러오는 중...',
    noData: '표시할 데이터가 없습니다',
    name: '이름',
    title: '제목',
    description: '설명',
    type: '유형',
    date: '날짜',
    createdAt: '생성일',
    updatedAt: '수정일',
    total: '합계',
    page: '페이지',
    email: '이메일',
    phone: '전화번호',
    user: '사용자',
    users: '사용자',
    success: '성공',
    error: '오류',
    networkError: '서버 연결에 실패했습니다',
    loadError: '데이터를 불러오지 못했습니다',
    saveSuccess: '성공적으로 저장되었습니다',
    saveError: '저장에 실패했습니다',
    deleteConfirmTitle: '정말 삭제하시겠습니까?',
    deleteConfirmContent: '이 작업은 되돌릴 수 없습니다.',
    deleteSuccess: '성공적으로 삭제되었습니다',
    deleteError: '삭제에 실패했습니다',
    updateSuccess: '성공적으로 업데이트되었습니다',
    updateError: '업데이트에 실패했습니다',
    copySuccess: '복사되었습니다!',
    requiredField: '이 필드는 필수입니다',
    all: '전체',
    none: '없음',
    unknown: '알 수 없음',
  },
  pt: {
    save: 'Salvar',
    saveSettings: 'Salvar configurações',
    cancel: 'Cancelar',
    delete: 'Excluir',
    edit: 'Editar',
    add: 'Adicionar',
    addNew: 'Adicionar novo',
    create: 'Criar',
    update: 'Atualizar',
    submit: 'Enviar',
    close: 'Fechar',
    back: 'Voltar',
    next: 'Próximo',
    previous: 'Anterior',
    confirm: 'Confirmar',
    yes: 'Sim',
    no: 'Não',
    search: 'Pesquisar',
    filter: 'Filtro',
    refresh: 'Atualizar',
    export: 'Exportar',
    import: 'Importar',
    view: 'Ver',
    viewDetails: 'Ver detalhes',
    actions: 'Ações',
    status: 'Status',
    enabled: 'Ativado',
    disabled: 'Desativado',
    active: 'Ativo',
    inactive: 'Inativo',
    loading: 'Carregando...',
    noData: 'Nenhum dado para exibir',
    name: 'Nome',
    title: 'Título',
    description: 'Descrição',
    type: 'Tipo',
    date: 'Data',
    createdAt: 'Criado em',
    updatedAt: 'Atualizado em',
    total: 'Total',
    page: 'Página',
    email: 'E-mail',
    phone: 'Número de telefone',
    user: 'Usuário',
    users: 'Usuários',
    success: 'Sucesso',
    error: 'Erro',
    networkError: 'Falha ao conectar ao servidor',
    loadError: 'Falha ao carregar dados',
    saveSuccess: 'Salvo com sucesso',
    saveError: 'Falha ao salvar',
    deleteConfirmTitle: 'Tem certeza de que deseja excluir isto?',
    deleteConfirmContent: 'Esta ação não pode ser desfeita.',
    deleteSuccess: 'Excluído com sucesso',
    deleteError: 'Falha ao excluir',
    updateSuccess: 'Atualizado com sucesso',
    updateError: 'Falha ao atualizar',
    copySuccess: 'Copiado!',
    requiredField: 'Este campo é obrigatório',
    all: 'Todos',
    none: 'Nenhum',
    unknown: 'Desconhecido',
  },
};
